import React from "react";
import Banner from "../components/Banner/Banner";
import Button from "../components/Button";
import Typewriter from "typewriter-effect";
import {
  Animation,
  FORWARD,
  FORWARD_REVERSE,
} from "./AnimationRunner/AnimationRunner";
import globeAnim from "../animations/globe";
import moonAnim from "../animations/moon";
import rocketAnim from "../animations/rocket";
import rocketFireAnim from "../animations/rocketFire";
import rocketLineAnim from "../animations/rocketLine";
import astronautAnim from "../animations/astronaut";
import satelliteAnim from "../animations/satellite";
import asteroid1Anim from "../animations/asteroid1";
import asteroid2Anim from "../animations/asteroid2";

const HeroSection = () => {
  return (
    <section className="">
      <div className="min-h-screen flex items-center justify-center -mt-20 px-9 sm:px-10 lg:px-12 relative">
        <Animation
          animationData={moonAnim}
          type={FORWARD}
          className="absolute hidden lg:block h-120 w-120 -top-64 -right-64"
          lineWidth={8}
        />

        <div className="container max-w-6xl mx-auto relative flex flex-col justify-center items-start">
          <Animation
            animationData={globeAnim}
            type={FORWARD}
            className="absolute hidden lg:block h-150 w-150 right-full mt-32 tailWagAnimation"
            lineWidth={8}
          />
          <Animation
            animationData={astronautAnim}
            type={FORWARD}
            className="absolute hidden lg:block h-80 w-80 bottom-full right-1/3 upDownAnimation delay"
            lineWidth={14}
            frameSpeed={2}
          />
          <Animation
            animationData={satelliteAnim}
            type={FORWARD}
            className="absolute hidden lg:block h-64 w-64 top-full -right-16 upDownAnimation"
            lineWidth={17}
            frameSpeed={1.5}
          />
          <Animation
            animationData={asteroid1Anim}
            type={FORWARD}
            className="absolute hidden lg:block h-48 w-48 -bottom-40 -left-20 upDownAnimation delay"
            lineWidth={20}
          />
          <Animation
            animationData={asteroid2Anim}
            type={FORWARD}
            className="absolute hidden lg:block h-48 w-48 -bottom-40 -left-40 upDownAnimation"
            lineWidth={20}
          />
          <div className="mb-5 inline-flex items-center rounded-full border border-black bg-white/80 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-gray-700 shadow-sm">
            📦 Archived Site
          </div>
          <Banner.Hero>
            Kuhaku has <b>pivoted into the afterlife.</b>
            <br className="hidden md:block" /> Gone, vibes stay.
          </Banner.Hero>
          <p className="mt-5 max-w-2xl text-base leading-7 text-gray-600 md:text-lg">
            Revenue may have flatlined, but the lore is thriving. This is our lovingly preserved graveyard of shipped work, chaotic experiments, and suspiciously ambitious ideas that somehow made it into production.
          </p>
          <div className="w-full mt-12 md:mt-16 relative">
            <div className="flex flex-col md:flex-row md:items-center gap-6 md:gap-8">
              <div className="flex-1 shadow rounded-xl py-4 px-5 bg-white min-h-16 flex items-center">
                <div className="text-gray-400 text-sm lg:text-base font-medium">
                  <Typewriter
                    options={{
                      strings: [
                        "Shipped before runway ran out",
                        "Synergized extremely hard",
                        "Moved fast, kept most things",
                        "Converted funding into memories",
                        "Launched delightfully weird things",
                        "Archived the chaos with care",
                        "Achieved pre-legendary status",
                      ],
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </div>
              </div>
              <Button text="Browse archive" size="lg" href="#works" />
            </div>
            <div className="absolute -top-80 right-0 hidden lg:block pointer-events-none">
              <Animation
                animationData={rocketAnim}
                type={FORWARD}
                className="absolute h-72 w-72 top-0 right-0"
                lineWidth={16}
              />
              <Animation
                animationData={rocketFireAnim}
                type={FORWARD_REVERSE}
                frameSpeed={3}
                className="absolute h-52 w-52 top-12 right-20"
                lineWidth={16}
              />
              <Animation
                animationData={rocketLineAnim}
                type={FORWARD_REVERSE}
                className="absolute h-80 w-80 top-32 right-40"
                lineWidth={16}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
